<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import SitePreviewPage from '@/views/apps/sites/SitePreviewPage.vue'

const sitesPageMeta = PageMeta.Sites as unknown as {
  Preview: { Meta: Record<string, unknown>; Title: string }
}

definePage({ meta: PageMeta.Sites.Preview.Meta })
setPageTitle(sitesPageMeta.Preview.Title)

const route = useRoute()

const siteGuid = computed(() => {
  const params = route.params as Record<string, string | string[] | undefined>
  const guid = params.guid

  return Array.isArray(guid) ? guid[0] : guid
})
</script>

<template>
  <SitePreviewPage
    v-if="siteGuid"
    :site-guid="siteGuid"
  />
</template>
